
var global_address;
var global_address_lat;
var global_address_lng;
var markers = [];
var marker = [];
var gl_location_map = '';
var gl_location_form = '';
var global_saddr = $(".mapPickUp_item.active .text").text();

var map, infoWindow;
function initMap() {
  /* ZOOM */
  var var_zoom = 8;
  if (navigator.geolocation) {
    var_zoom = 17;
  }


  var start_lat = Number( document.querySelector('.mapPickUp_item.first').getAttribute('data-lat') );
  var start_lng = Number( document.querySelector('.mapPickUp_item.first').getAttribute('data-lng') );
  /* MAP */
  map = new google.maps.Map(document.getElementById('map'), {
    //center: {lat: 33.29506815180493, lng: 44.42414332612292},
    center: {lat: start_lat, lng: start_lng },
    zoom: var_zoom,
    //gestureHandling: 'greedy', /* mouse scroll */

    mapTypeId:google.maps.MapTypeId.ROADMAP,
    mapTypeControl:!1,
    streetViewControl:!1,
    fullscreenControl:!1,
    scaleControl:!1,
    zoomControl:!0,
    disableDoubleClickZoom:!0,
    clickableIcons:!1,
    styles: [{"featureType":"landscape", "stylers":[{"saturation":-100}, {"lightness":65}, {"visibility":"on"}]}, {"featureType":"poi", "stylers":[{"saturation":-100}, {"lightness":51}, {"visibility":"simplified"}]}, {"featureType":"road.highway", "stylers":[{"saturation":-100}, {"visibility":"simplified"}]}, {"featureType":"road.arterial", "stylers":[{"saturation":-100}, {"lightness":30}, {"visibility":"on"}]}, {"featureType":"road.local", "stylers":[{"saturation":-100}, {"lightness":40}, 
    {"visibility":"on"}]}, {"featureType":"water", "elementType":"labels", "stylers":[{"visibility":"on"}, {"lightness":-25}, {"saturation":-100}]}, {"featureType":"water", "elementType":"geometry", "stylers":[{"hue":"#ffff00"}, {"lightness":-25}, {"saturation":-97}]}]

  });
  infoWindow = new google.maps.InfoWindow;



  // MARKER
  /*
  for (let i = 0; i < document.querySelector('.mapPickUp_item').length; ++i) {
    var start_lat = Number( document.querySelector('.mapPickUp_item')[i].getAttribute('data-lat') );
    var start_lng = Number( document.querySelector('.mapPickUp_item')[i].getAttribute('data-lng') );
    const marker = new google.maps.Marker({
      position: {
        lat: start_lat,
        lng: start_lng,
      },
      map: map,
    });
  }
*/


const infowindow = new google.maps.InfoWindow({
  content: '<div class="map_addressText_js"></div>',
});


for (let i = 0; i < document.querySelectorAll('.mapPickUp_items .mapPickUp_item').length; i++ ) {

  var start_lat = Number( document.querySelectorAll('.mapPickUp_items .mapPickUp_item')[i].getAttribute('data-lat') );
  var start_lng = Number( document.querySelectorAll('.mapPickUp_items .mapPickUp_item')[i].getAttribute('data-lng') );
  const marker = new google.maps.Marker({
    // The below line is equivalent to writing:
    // position: new google.maps.LatLng(-34.397, 150.644)
    //position: { lat: 33.29506815180493, lng: 44.42414332612292 },
    position: { lat: start_lat, lng: start_lng },
    map: map,
  });


  google.maps.event.addListener(marker, "click", () => {
    infoWindow.close();
    $(".mapPickUp_item").removeClass("active");
    $(".mapPickUp_item[data-index='"+i+"']").addClass("active");
    infowindow.open(map, marker);
    func_text_infowindow ();
 
    console.log(i);
    console.log(i);
    console.log(i);


  });
  $("body").on("click", ".mapPickUp_item[data-index='"+i+"']", function() {
    $(".mapPickUp_item").removeClass("active");
    $(".mapPickUp_item[data-index='"+i+"']").addClass("active");
    
    var time = 0;
    if ( $(window).width() <= 999 ) {
      var var_this = $(this);
      $(".map_height_js").slideUp(300);
      time = 500;

      setTimeout(function() {
        var order = Number(var_this.attr("data-order")) + 1;
        $('html, body').animate({ scrollTop: var_this.offset().top - 100 }, 0);  
        $(".map_height_js").css("order", order);
        $(".map_height_js").slideDown(300);
      }, 301);
    }

    setTimeout(function() {
      infoWindow.close();
      var start_lat = Number( $('.mapPickUp_item.active').attr('data-lat') );
      var start_lng = Number( $('.mapPickUp_item.active').attr('data-lng') );
      map.panTo({lat: start_lat, lng: start_lng}); 
      infowindow.open(map, marker);
      func_text_infowindow ();
     }, time);


    //panTo
  });

  if ( i == 0 ) {
    infowindow.open(map, marker);
    $(".mapPickUp_item[data-index='"+i+"']").addClass("active");
    func_text_infowindow ();

    setTimeout(function() {
      func_text_infowindow ();
     }, 1500);
     setTimeout(function() {
      func_text_infowindow ();
     }, 4000);

  }
}
function func_text_infowindow () {
  var saddr = global_saddr;
  var daddr = $(".mapPickUp_item.active").attr("data-lat")+','+$(".mapPickUp_item.active").attr("data-lng");
  text_infowindow = '<div>'+$(".mapPickUp_item.active").html()+'<div class="link"><a href="http://maps.google.com/maps?saddr='+saddr+'&daddr='+daddr+'" target="_blank">GET DIRECTIONS</a></div><div>';
  $(".map_addressText_js").html(text_infowindow);

}


  /* Try HTML5 geolocation. */
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(position) {
      // geo location - position
      //go_to_position (position)
      global_saddr = position.coords.latitude+','+position.coords.longitude;
    }, function() {
      /* ERROR */
      //var position = [];
      //position.coords = [];
      //position.coords.latitude = 33.286860;
      //position.coords.longitude = 44.351286;
      //go_to_position (position);
      //handleLocationError(true, infoWindow, map.getCenter());
    });
  } else {
    /* ERROR */
    /* Browser doesn't support Geolocation */

    //var position = [];
    //position.coords = [];
    //position.coords.latitude = 33.286860;
    //position.coords.longitude = 44.351286;
    //go_to_position (position);

    //handleLocationError(false, infoWindow, map.getCenter());
  }


}

function handleLocationError(browserHasGeolocation, infoWindow, pos) {
  /*infoWindow.setPosition(pos); */
  /*infoWindow.setContent(browserHasGeolocation ?  'Error: The Geolocation service failed.' : 'Error: Your browser doesn\'t support geolocation.');*/
  if ( browserHasGeolocation ) {
    /* infoWindow.setContent('Error: The Geolocation service failed.'); */
    infoWindow.close();
  } else {
    /* infoWindow.setContent( 'Error: Your browser doesn\'t support geolocation.'); */
    infoWindow.close();
  }
  infoWindow.open(map);
}


function func_get_address(results, type) {
  var var_return = undefined;
  if ( results == undefined ) {
    return '';
  }
  for(var i = 0; i < results[0].address_components.length; i++) {
    if (type == 'city' && results[0].address_components[i].types[0] == 'locality') {
      var_return = results[0].address_components[i].long_name;
    } else if ( type == 'street' && results[0].address_components[i].types[0] == 'route'  ) {
      var_return = results[0].address_components[i].short_name;
    } else if ( type == 'home' && results[0].address_components[i].types[0] == 'street_number'  ) {
      var_return = results[0].address_components[i].short_name;
    } 
  }

  if ( var_return == undefined ) {
    for(var i = 0; i < results[0].address_components.length; i++) {
      if ( type == 'street' && results[0].address_components[i].types[0] == 'administrative_area_level_1'  ) {
        var_return = results[0].address_components[i].short_name;
      } else if ( type == 'home'  && results[0].address_components[i].types[0] == "administrative_area_level_2" ) {
        var_return = results[0].address_components[i].short_name;
      } 
    } 
  }


  
    localStorage.setItem('ls_location', $("#checkout_shipping_address_company").val());
    

  return var_return;
}


function getCookie(data) {
  var matches = document.cookie.match(new RegExp(
    "(?:^|; )" + data.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}











